module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-container-full"
  }, [_c('div', {
    staticClass: "tab-head"
  }, [_c('div', {
    staticClass: "tab-menu-wrap box-type"
  }, _vm._l((_vm.orgSelections), function(org) {
    return _c('button', {
      key: org.id,
      staticClass: "font-body-style3 tab-menu",
      class: {
        'is-active': _vm.activeOrg === org.id,
        'center-filter': org.id === 'center',
        'center-selecting': org.id === 'center' && _vm.showCenterFilter && _vm.activeOrg !== 'center'
      },
      attrs: {
        "type": "button",
        "data-tab": ("tab1-con" + (org.index)),
        "aria-label": "tab메뉴",
        "title": "tab메뉴"
      },
      on: {
        "click": function($event) {
          return _vm.selectOrg(org.id)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(org.displayLabel)
      }
    })])
  }), 0), _vm._v(" "), (_vm.showCenterFilter) ? _c('div', {
    staticClass: "center-filter-list",
    attrs: {
      "id": "centerFilterList"
    }
  }, [_c('div', {
    staticClass: "pc-view"
  }, [_c('ul', {
    staticClass: "center-filter-list-inner"
  }, [_vm._l((_vm.centerList), function(center) {
    return _c('li', {
      key: center.id
    }, [_c('button', {
      staticClass: "btn btn-xsm btn-secondary",
      class: {
        'on': _vm.activeCenter === center.id
      },
      attrs: {
        "type": "button",
        "aria-label": "filter 메뉴",
        "title": "filter 메뉴"
      },
      on: {
        "click": function($event) {
          return _vm.selectCenter(center.id)
        }
      }
    }, [_vm._v("\n              " + _vm._s(center.label) + "\n            ")])])
  }), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-close only-icon close-modal",
    attrs: {
      "type": "button",
      "aria-label": "닫기",
      "title": "닫기"
    },
    on: {
      "click": _vm.closeCenterFilter
    }
  }, [_c('i', {
    staticClass: "ico ico-x-bl"
  })])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mo-view"
  }, [_c('div', {
    staticClass: "center-filter-top"
  }, [_c('strong', {
    staticClass: "h4-title"
  }, [_vm._v("센터")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-close only-icon close-modal",
    attrs: {
      "type": "button",
      "aria-label": "닫기 버튼",
      "title": "닫기 버튼"
    },
    on: {
      "click": _vm.closeCenterFilter
    }
  }, [_c('i', {
    staticClass: "ico ico-x-bl"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "center-filter-list-inner"
  }, _vm._l((_vm.centerList), function(center) {
    return _c('li', {
      key: center.id
    }, [_c('button', {
      staticClass: "btn",
      class: {
        'on': _vm.activeCenter === center.id
      },
      attrs: {
        "type": "button",
        "aria-label": "필터 버튼",
        "title": "필터 버튼"
      },
      on: {
        "click": function($event) {
          return _vm.selectCenter(center.id)
        }
      }
    }, [_vm._v("\n              " + _vm._s(center.label) + "\n            ")])])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-content__wrap box-line"
  }, [_vm._l((_vm.orgSelections), function(org) {
    return _c('div', {
      key: org.id,
      staticClass: "tab-content flex-direction",
      class: {
        'is-active': _vm.activeOrg === org.id
      },
      attrs: {
        "id": ("tab1-con" + (org.index))
      }
    }, [_c('div', {
      staticClass: "tab-container-sort"
    }, [_c('div', {
      staticClass: "tab-menu-wrap scroll-tab"
    }, _vm._l((org.menuItems), function(menu) {
      return _c('button', {
        key: menu.id,
        staticClass: "font-body-style3 tab-menu",
        class: {
          'is-active': _vm.activeMenu === menu.id
        },
        attrs: {
          "type": "button",
          "aria-label": "탭메뉴 버튼",
          "title": "탭메뉴 버튼"
        },
        on: {
          "click": function($event) {
            return _vm.selectMenu(menu.id)
          }
        }
      }, [_vm._v("\n            " + _vm._s(menu.label) + "\n            "), _c('span', {
        staticClass: "result-count"
      }, [_vm._v(_vm._s(_vm.formatCount(menu.count)) + "건")])])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "form-section mt-32"
    }, [_c('ul', {
      staticClass: "sort-wrap"
    }, [_c('li', [_c('div', {
      staticClass: "activity-item"
    }, [_c('span', {
      staticClass: "th-name"
    }, [_vm._v("순서")]), _vm._v(" "), _c('div', {
      staticClass: "input-area"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.searchFilters.sort),
        expression: "searchFilters.sort"
      }],
      attrs: {
        "title": "정렬 기준 선택"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.searchFilters, "sort", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, _vm.onFilterChange]
      }
    }, [_c('option', {
      attrs: {
        "value": "RANK"
      }
    }, [_vm._v("정확도순")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "DATE"
      }
    }, [_vm._v("최신순")])])])])]), _vm._v(" "), _c('li', [_c('div', {
      staticClass: "activity-item"
    }, [_c('span', {
      staticClass: "th-name"
    }, [_vm._v("기간")]), _vm._v(" "), _c('div', {
      staticClass: "input-area"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.searchFilters.period),
        expression: "searchFilters.period"
      }],
      attrs: {
        "title": "기간 선택"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.searchFilters, "period", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, _vm.onFilterChange]
      }
    }, [_c('option', {
      attrs: {
        "value": "ALL"
      }
    }, [_vm._v("전체 기간")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "today"
      }
    }, [_vm._v("오늘")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1month"
      }
    }, [_vm._v("1개월")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1year"
      }
    }, [_vm._v("1년")])])])])]), _vm._v(" "), _c('li', [_c('div', {
      staticClass: "activity-item"
    }, [_c('span', {
      staticClass: "th-name"
    }, [_vm._v("기준")]), _vm._v(" "), _c('div', {
      staticClass: "input-area"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.searchFilters.field),
        expression: "searchFilters.field"
      }],
      attrs: {
        "title": "검색 범위 선택"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.searchFilters, "field", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, _vm.onFilterChange]
      }
    }, [_c('option', {
      attrs: {
        "value": "ALL"
      }
    }, [_vm._v("전체 범위")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "TITLE"
      }
    }, [_vm._v("제목")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "CONTENT"
      }
    }, [_vm._v("내용")])])])])]), _vm._v(" "), (_vm.activeMenu === 'ALL') ? _c('li', [_c('div', {
      staticClass: "activity-item"
    }, [_c('span', {
      staticClass: "th-name"
    }, [_vm._v("표시")]), _vm._v(" "), _c('div', {
      staticClass: "input-area"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.searchFilters.display),
        expression: "searchFilters.display"
      }],
      attrs: {
        "title": "표시 개수 선택"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.searchFilters, "display", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, _vm.onFilterChange]
      }
    }, [_c('option', {
      attrs: {
        "value": "3"
      }
    }, [_vm._v("3개씩")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "10"
      }
    }, [_vm._v("10개씩")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "30"
      }
    }, [_vm._v("30개씩")])])])])]) : _vm._e(), _vm._v(" "), _c('li', [_c('button', {
      staticClass: "btn btn-primary btn-form-size",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.handleFilterSearch
      }
    }, [_vm._v("\n                검색\n              ")])])])]), _vm._v(" "), (_vm.hasSearched) ? _c('div', {
      staticClass: "tab-content mt-24 sort-type"
    }, _vm._l((_vm.displayCategories), function(category) {
      return _c('div', {
        key: category.key,
        staticClass: "result-category"
      }, [_c('div', {
        staticClass: "article-result",
        class: {
          'no-result': category.items.length === 0
        }
      }, [_vm._v("\n              " + _vm._s(category.title) + "\n              "), _c('span', {
        staticClass: "result-keyword"
      }, [_vm._v("(" + _vm._s(category.count) + ")")])]), _vm._v(" "), (category.items.length === 0) ? _c('div', [_vm._v("검색 결과가 없습니다.")]) : _vm._e(), _vm._v(" "), (category.items.length > 0) ? _c('ul', {
        staticClass: "article-list"
      }, _vm._l((category.items), function(item) {
        return _c('li', {
          key: item.id,
          staticClass: "article-item"
        }, [_c('a', {
          staticClass: "article-link",
          attrs: {
            "href": item.linkUrl,
            "aria-label": "본문 바로가기",
            "title": "본문 바로가기"
          }
        }, [(item.imageUrl && !item.imageError) ? _c('div', {
          staticClass: "article-thumbnail article-image-container"
        }, [_c('img', {
          staticClass: "article-image",
          attrs: {
            "src": item.imageUrl,
            "alt": ""
          },
          on: {
            "error": function($event) {
              return _vm.handleImageError(item)
            },
            "load": function($event) {
              return _vm.handleImageLoad(item)
            }
          }
        })]) : _c('div', {
          staticClass: "article-thumbnail"
        }, [_c('div', {
          staticClass: "article-image-placeholder"
        })]), _vm._v(" "), _c('div', {
          staticClass: "article-details"
        }, [_c('time', {
          staticClass: "article-date",
          attrs: {
            "datetime": item.date
          }
        }, [_vm._v("\n                      " + _vm._s(_vm.formatDate(item.date)) + "\n                    ")]), _vm._v(" "), _c('h5', {
          staticClass: "article-title",
          domProps: {
            "innerHTML": _vm._s(_vm.highlightKeyword(item.title))
          }
        }), _vm._v(" "), _c('p', {
          staticClass: "article-description",
          domProps: {
            "innerHTML": _vm._s(_vm.highlightKeyword(item.description))
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "article-bottom"
        }, [_c('div', {
          staticClass: "article-keywords"
        }, [_c('span', [_vm._v("연관 키워드 ")]), _vm._v(" "), _vm._l((item.tags), function(tag) {
          return _c('span', {
            key: tag,
            staticClass: "article-tag",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                $event.preventDefault();
                return _vm.searchByTag(tag)
              }
            }
          }, [_vm._v("\n                          #" + _vm._s(tag) + "\n                        ")])
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "color-gray"
        }, [_vm._v("\n                        " + _vm._s(item.organization) + " : " + _vm._s(_vm.formatTimestamp(item.timestamp)) + "\n                      ")])])])])])
      }), 0) : _vm._e(), _vm._v(" "), (category.hasMore) ? _c('div', {
        staticClass: "button-area btn-load-more"
      }, [_c('button', {
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.loadMoreCategory(category.key)
          }
        }
      }, [_c('i', {
        staticClass: "ico ico-plus"
      }), _vm._v("\n                더보기\n              ")])]) : _vm._e()])
    }), 0) : _vm._e()])])
  }), _vm._v(" "), (_vm.activeMenu !== 'ALL' && _vm.hasSearched && _vm.currentResults.totalCount > 0) ? _c('nav', {
    staticClass: "pagination-container"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.currentPage <= 1
    }
  }, [_c('a', {
    staticClass: "page-link btn-page",
    attrs: {
      "href": "#",
      "title": "« 입력"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPage(1)
      }
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.currentPage <= 1
    }
  }, [_c('a', {
    staticClass: "page-link btn-page",
    attrs: {
      "href": "#",
      "title": "‹ 입력"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPage(_vm.currentPage - 1)
      }
    }
  }, [_vm._v("‹")])]), _vm._v(" "), _vm._l((_vm.visiblePages), function(page) {
    return _c('li', {
      key: page,
      staticClass: "page-item",
      class: {
        active: page === _vm.currentPage,
        'pc-only': _vm.shouldHideOnMobile(page)
      }
    }, [_c('a', {
      staticClass: "page-link",
      attrs: {
        "href": "#",
        "title": "{{ page }} 페이지"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.goToPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.currentPage >= _vm.totalPages
    }
  }, [_c('a', {
    staticClass: "page-link btn-page",
    attrs: {
      "href": "#",
      "title": "› 입력"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPage(_vm.currentPage + 1)
      }
    }
  }, [_vm._v("›")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.currentPage >= _vm.totalPages
    }
  }, [_c('a', {
    staticClass: "page-link btn-page",
    attrs: {
      "href": "#",
      "title": "» 입력"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPage(_vm.totalPages)
      }
    }
  }, [_vm._v("»")])])], 2)]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef20e356"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/search/SearchContent.vue
// module id = 1530
// module chunks = 6